import axios from 'axios';
import { appSettings } from './appSettings';


  const axiosInstance = axios.create({
    baseURL: appSettings.APIM_BASE_URL,
  });

  const configureApiClient = async (config: any) => {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    config.headers['Ocp-Apim-Subscription-Key'] = appSettings.APIM_KEY;
    return config;
  };

  // Axios Interceptor
 
  axiosInstance.interceptors?.request?.use((config) => configureApiClient(config));
  

export default axiosInstance;


